import { Hammer, Car, CircleDot, ParkingSquare, CloudHail, Tag, ImageDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

const iconMap = { Hammer, Car, CircleDot, ParkingSquare, CloudHail, Tag, ImageDown };

const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="relative py-20 md:py-28 bg-[#0c0c0c]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
              <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
              {t.services.eyebrow}
            </div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tight">
              {t.services.title}
            </h2>
          </div>
          <a
            href={BRAND.whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 hover:border-white/40 text-white font-semibold transition self-start"
            data-testid="services-whatsapp-btn"
          >
            <MessageCircle className="w-4 h-4" />
            {t.common.sendOnWhatsApp}
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.services.items.map((s, i) => {
            const Icon = iconMap[s.icon] || Hammer;
            // Make first card span 2 cols on lg for bento-style rhythm
            const span = i === 0 ? "lg:col-span-2" : "";
            return (
              <div
                key={s.t}
                className={`relative rounded-2xl border border-white/10 bg-gradient-to-br from-[#141414] to-[#0f0f0f] p-6 md:p-7 overflow-hidden hover:border-[#e10600]/40 transition ${span}`}
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#e10600]/12 border border-[#e10600]/30 flex items-center justify-center shrink-0">
                    <Icon className="w-6 h-6 text-[#e10600]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display font-bold text-lg md:text-xl text-white">{s.t}</h3>
                    <p className="mt-1.5 text-white/60 text-sm md:text-[15px] leading-relaxed">{s.d}</p>
                  </div>
                </div>
                <div className="pointer-events-none absolute -right-16 -bottom-16 w-48 h-48 rounded-full bg-[#e10600]/5 blur-3xl" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
